import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  InputAdornment,
  IconButton
} from '@mui/material'
import {
  Visibility,
  VisibilityOff,
  Restaurant,
  Login as LoginIcon
} from '@mui/icons-material'
import { useAuth } from '../contexts/AuthContext'

const AdminLogin = () => {
  const navigate = useNavigate()
  const { loginAdmin, isAuthenticated } = useAuth()
  const { register, handleSubmit, formState: { errors } } = useForm()
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  React.useEffect(() => {
    if (isAuthenticated) {
      const user = JSON.parse(localStorage.getItem('user'))
      if (user?.tipo === 'agroeconomia') {
        navigate('/agroeconomia')
      } else if (user?.tipo === 'educacao') {
        navigate('/educacao')
      } else if (user?.tipo === 'produtor') {
        navigate('/produtor')
      }
    }
  }, [isAuthenticated, navigate])

  const onSubmit = async (data) => {
    setError('')
    setLoading(true)

    try {
      const result = await loginAdmin(data.cpf, data.password)
      if (result.success) {
        const user = JSON.parse(localStorage.getItem('user'))
        if (user?.tipo === 'agroeconomia') {
          navigate('/agroeconomia')
        } else if (user?.tipo === 'educacao') {
          navigate('/educacao')
        } else {
          navigate('/')
        }
      } else {
        setError(result.message)
      }
    } catch (err) {
      setError('Erro ao fazer login. Tente novamente.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Restaurant sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom>
            Merenda Escolar
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Área Administrativa
          </Typography>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          <TextField
            fullWidth
            label="CPF"
            margin="normal"
            {...register('cpf', {
              required: 'CPF é obrigatório',
              pattern: {
                value: /^\d{11}$/,
                message: 'CPF deve conter 11 dígitos'
              }
            })}
            error={!!errors.cpf}
            helperText={errors.cpf?.message}
            placeholder="00000000000"
          />

          <TextField
            fullWidth
            label="Senha"
            type={showPassword ? 'text' : 'password'}
            margin="normal"
            {...register('password', {
              required: 'Senha é obrigatória',
              minLength: {
                value: 6,
                message: 'Senha deve ter no mínimo 6 caracteres'
              }
            })}
            error={!!errors.password}
            helperText={errors.password?.message}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            sx={{ mt: 3, mb: 2 }}
            startIcon={<LoginIcon />}
            disabled={loading}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>

          <Box sx={{ textAlign: 'center', mt: 2 }}>
            <Link
              to="/login"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <Typography variant="body2" color="primary">
                Voltar para login de produtor
              </Typography>
            </Link>
          </Box>
        </form>
      </Paper>
    </Container>
  )
}

export default AdminLogin

